import React from "react";
import { Flex } from "@chakra-ui/react";
import { ColorVariantEnum, HeadingSizeEnum, Text, theme } from "@foleon/atomic";

/**
 * @summary Creates a navbar that allows for us to switch between pages
 * @return TopBar component
*/
const TopBar = () => {

	return (
		<Flex
			as="nav"
			align="center"
			width="100%"
			height="62px"
			justify="space-between"
			wrap="wrap"
			bg={theme.colors.primary.blue}
			color={ColorVariantEnum.WHITE}
		>
			<Flex display="inline-block" padding="5px 10px">
				<Text.Heading
					size={HeadingSizeEnum.EXTRA_LARGE}
					colorVariant={ColorVariantEnum.WHITE}
				>
                        Foleon
				</Text.Heading>
			</Flex>
		</Flex>
	);
};

export default TopBar;